import styled from "styled-components";

export const Tooltip = styled.div`
background: white;
padding: 5px 10px;
box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
border-radius: 4px; 
`;